import { useState, useEffect } from "react";
import { Dialog, DialogContent } from "./ui/dialog";
import { Sparkles, ChevronRight } from "lucide-react";
import { useAppearance } from "../contexts/AppearanceContext";

export default function ChangelogModal({ open, onOpenChange }) {
  const [releases, setReleases] = useState([]);
  const appearance = useAppearance();
  const tc500 = appearance.colors?.["500"] || "#3B82F6";
  const tc50 = appearance.colors?.["50"] || "#EFF6FF";

  useEffect(() => {
    if (open) {
      fetch("/changelog.json?" + Date.now())
        .then(r => r.json())
        .then(data => {
          setReleases(data || []);
          // Mark as seen
          if (data?.[0]?.version) {
            localStorage.setItem("pipe4_changelog_seen", data[0].version);
          }
        })
        .catch(() => setReleases([]));
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl !p-0 overflow-hidden" style={{ height: "85vh" }} data-testid="changelog-modal">
        <div className="px-6 pt-5 pb-3 border-b border-slate-100 flex-shrink-0">
          <p className="font-heading font-bold text-lg text-slate-900 flex items-center gap-2">
            <Sparkles className="w-5 h-5" style={{ color: tc500 }} />Atualizações
          </p>
          <p className="text-[11px] text-slate-400 mt-0.5">Veja o que há de novo no sistema.</p>
        </div>
        <div className="overflow-y-auto flex-1 px-6 pb-6 pt-3 space-y-6">
          {releases.map((release, ri) => (
            <div key={ri}>
              <div className="flex items-center gap-2 mb-3">
                <span className="text-xs font-bold text-white px-2 py-0.5 rounded-full" style={{ backgroundColor: tc500 }}>
                  v{release.version}
                </span>
                <span className="text-xs text-slate-400">
                  {new Date(release.date + "T12:00:00").toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" })}
                </span>
              </div>
              <ul className="space-y-1.5">
                {release.items.map((item, ii) => (
                  <li key={ii} className="flex items-start gap-2 text-sm text-slate-600 leading-relaxed">
                    <ChevronRight className="w-3.5 h-3.5 flex-shrink-0 mt-0.5" style={{ color: tc500 }} />
                    {item}
                  </li>
                ))}
              </ul>
              {ri < releases.length - 1 && <div className="border-b border-slate-100 mt-5" />}
            </div>
          ))}
          {releases.length === 0 && (
            <p className="text-sm text-slate-400 text-center py-8">Nenhuma atualização disponível.</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function useChangelogBadge() {
  const [hasNew, setHasNew] = useState(false);

  useEffect(() => {
    fetch("/changelog.json?" + Date.now())
      .then(r => r.json())
      .then(data => {
        if (data?.[0]?.version) {
          const seen = localStorage.getItem("pipe4_changelog_seen");
          setHasNew(seen !== data[0].version);
        }
      })
      .catch(() => {});
  }, []);

  return hasNew;
}
